import type { FieldSchemaModel } from '@/shared/generated'

import React from 'react'

import { Checkbox } from '@/shared/components/ui/checkbox-native'
import { cn } from '@/shared/lib/utils'

export function BasicCheckboxEditorField(props: {
	value: boolean
	onChange: (value: boolean) => void
	field?: FieldSchemaModel
	disabled?: boolean
	disabledReason?: string
}) {
	const checked = Boolean(props.value)
	const onChange = () => props.onChange?.(!checked)

	return (
		<Checkbox
			disabled={props.disabled}
			className={cn(
				'm-auto',
				!props.field?.params?.editable && 'pointer-events-none'
			)}
			checked={checked}
			onChange={onChange}
		/>
	)
}
